export class Ftp {

  FtpServerIP:string;
  Port:string;
  Username:string;
  Password:string;

  constructor(json:any) {

    if(json!=null) {
      this.FtpServerIP = json.FtpServerIP;
      this.Port = json.Port;
      this.Password = json.Password;
      this.Username = json.Username;
    }
  }

}
